<template>
    <q-table :title="title"
             :loading="loading"
             :columns="columns"
             :visible-columns="columnsVisible"
             :data="dataSource"
             :filter="filter"
             row-key="Id"
             :pagination.sync="pagination"
             :rows-per-page-options="[ 5, 10, 15, 25, 50, 100 ]"
             @request="onRequest">

        <template v-slot:top>
            <q-toolbar v-if="true">
                <div class="q-table__title">
                    <p>{{ title }}</p>
                    <p :style="{display: loading ? 'inline-block' : 'none'}"><span style="font-size: 16px;">This may take up to 30 seconds to load data. Please wait...</span></p>
                </div>
                <q-space></q-space>
                <q-input outlined dense clearable clear-icon="close" v-model="filter" placeholder="Search" debounce="300" style="width:300px">
                    <template v-slot:prepend>
                        <q-icon name="search"></q-icon>
                    </template>
                </q-input>
            </q-toolbar>
        </template>

        <template v-slot:body-cell-Actions="props">
            <q-td :props="props" auto-width>
                <div class="q-gutter-xs">
                    <q-btn label="Details"
                           color="primary"
                           @click="onViewActionClick(props.key, props.rowIndex, props.row)">
                    </q-btn>
                    <q-btn label="Process"
                           color="primary"
                           @click="onProcessActionClick(props.key)">
                    </q-btn>
                    <q-btn label="Download"
                           color="primary"
                           @click="onDownloadActionClick(props.key)">
                    </q-btn>
                </div>
            </q-td>
        </template>
    </q-table>
</template>

<script>
    export { default } from './processed-files-list-screen.js'
</script>